import { gql } from "@apollo/client";
import moment from 'moment';

export const GET_ALL_PROFESIONALES = gql`
    query GetProfesionales($idDelegacion: Int, $activo: Boolean) {
        profesionales(idDelegacion: $idDelegacion, activo: $activo) {
            idProfesional
            nombre
            apellido
            activo
            cod_SAP
            idTipoProfesional
            idTipoProfesionalNavigation {
                descripcion
            }
            idCalificacionNavigation{
                descripcion
            }
            idClaseMonitoreoNavigation{
                descripcion
            }
            idEspecialidad
            fechaProximoMonitoreo
            gestionReclamoProfesional {
                id
            }
        }
    }
`;

export const adaptProfesional = (profesional) => {
  return {
    id: profesional?.idProfesional,
    nombreCompleto: `${profesional?.nombre} ${profesional?.apellido}`,
    nombre: profesional?.nombre,
    apellido: profesional?.apellido,
    idTipoProfesional: profesional?.idTipoProfesional,
    tipoProfesional: profesional?.idTipoProfesionalNavigation?.descripcion,
    especialidad: profesional?.idEspecialidad,
    calificacionMonitoreo: profesional?.idClaseMonitoreoNavigation?.descripcion,
    activo: profesional?.activo,
    fechaProximoMonitoreo: profesional?.fechaProximoMonitoreo,
    poseeReclamos: profesional?.gestionReclamoProfesional?.length > 0,
    estadoAPP: profesional?.estadoAPP,
    codigoSAP: profesional?.cod_SAP
  };
};

const adaptProfesionalesArray = (profesionalesData) => {
  return structuredClone(profesionalesData?.profesionales)?.
  map((profesional) => adaptProfesional(profesional)) || [];
};

export default adaptProfesionalesArray;